import React from "react";
import "./style.css";

const PaginationControls = ({ currentPage, totalPages, onPageChange }) => {
    return (
        <div className="pagination-controls">
            <button 
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
            >
                Previous
            </button>
            <span> Page {currentPage} of {totalPages} </span>
            <button 
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                Next
            </button>
        </div>
    );
};

export default PaginationControls;
